// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2g8qC","content":"Consent_content__3buWJ","footer":"Consent_footer__1gjaL"};